import React, { createContext, useContext, useState } from 'react';

const AISupportContext = createContext();

export const useAISupport = () => {
    const context = useContext(AISupportContext);
    if (!context) {
        throw new Error('useAISupport must be used within an AISupportProvider');
    }
    return context;
};

export const AISupportProvider = ({ children }) => {
    const [aiSupportVisible, setAiSupportVisible] = useState(false);

    const openAISupport = () => setAiSupportVisible(true);
    const closeAISupport = () => setAiSupportVisible(false);

    return (
        <AISupportContext.Provider value={{
            aiSupportVisible,
            openAISupport,
            closeAISupport
        }}>
            {children}
        </AISupportContext.Provider>
    );
};

export default AISupportContext;
